// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","745":"component---src-pages-privacy-js","854":"component---src-pages-support-js"}[chunkId] + "-" + {"293":"416a6ef083fd526826fb","745":"76fdcebd2804a9a227b7","854":"262541f0763fda96ad70"}[chunkId] + ".js";
};